module.exports = __webpack_public_path__ + "img/live-text.ce058f86.png";